<template>
  <div class="about" >
    <el-container class="layout-container" >
      <!--头部信息-->
      <el-header class="el-header" >
        <div class="title">
          <span>ARENA</span>
        </div>

        <div class="guideMenu" >
          <el-menu class="el-menu"
                   background-color="#C6E2FF"
                   active-text-color="#606266"
                   mode="horizontal"
          >
            <el-submenu index="1">
              <template slot="title">Language</template>
              <el-menu-item class="guideMenu" index="1-1">
                <router-link tag='a' to="/guide" style="color: #303133">
                  English
                </router-link>
              </el-menu-item>

              <el-menu-item class="guideMenu" index="1-2">
                <router-link tag='a' to="guide" style="color: #303133">
                  简体中文
                </router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>

      </el-header>
      <!--      主题信息-->
      <el-main id="largeFont" class="el-main" style="height: 85vh">
        <el-steps :active="activeStep" finish-status="success">
          <el-step title="Step 1"></el-step>
          <el-step title="Step 2"></el-step>
          <el-step title="Step 3"></el-step>
          <el-step title="Step 4"></el-step>
          <el-step title="Step 5"></el-step>
        </el-steps>

        <el-card v-show="activeStep === 0" style="height: 60vh;margin-top: 40px;font-size: 18px">
          <p class="cnParagraph">
            请跟随本指导来完成这次的用户调查。
          </p>
          <p class="cnParagraph">
            为了更好的展示效果，请使用 PC 访问。
          </p>
        </el-card>
        <el-card v-show="activeStep === 1" style="height: 60vh;margin-top: 40px;font-size: 18px">
          <ul>
            <li style="margin-bottom: 15px" class="cnParagraph">
              请跟随这个
              <router-link tag='a' target='_blank' to="/" >
                链接
              </router-link>
              来访问 ARENA 系统。
            </li>
            <li style="margin-bottom: 15px" class="cnParagraph">
              请跟随这个
              <router-link tag='a' target='_blank' to="/zh-cn/about" >
                链接
              </router-link>
              来访问 ARENA 系统的说明文档。
            </li>
          </ul>
          <div style="line-height: 40px" class="cnParagraph">
            首先，请参考上述两个链接来熟悉如何使用 ARENA 系统。为了掌握如何使用，请特别仔细阅读说明文档中的 "how to use it" 部分。
            <br>
            在这一步，不需要关心如何完成用户调查，只需了解如何使用 ARENA 系统即可。
          </div>
        </el-card>
        <el-card v-show="activeStep === 2" style="height: 60vh;margin-top: 40px;font-size: 18px;">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/step4.jpg" class="image">
          </div>
          <div style="line-height: 40px" class="cnParagraph">
            当您大概了解 ARENA 系统的功能后，请尝试用给出的样例SQL来观察 best plan 和 alternative plan 之间的差别。
            <br>
            找一找 best plan 与 alternative plan 之间的差别并检查这些差别是如何影响最终 cost 的。尝试思考为什么会是这样的影响。
          </div>
        </el-card>
        <el-card v-show="activeStep === 3" style="margin-top: 40px; font-size: 18px">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/feedback.jpg" class="image">
          </div>
          <div style="line-height: 20px">
            <p class="cnParagraph">
              您已经知道如何使用样例SQL来操作 ARENA 系统，并能基本理解其返回结果的含义。
            </p>
            <p style="color: #409EFF" class="cnParagraph">
              现在，来到了此次用户调查的关键部分，请您仔细查看样例SQL中 "5.sql" 和 “6.sql" 返回的结果，并发送给我们相应的反馈。
            </p>
            <p class="cnParagraph">
              对于这两条SQL（5.sql 和 6.sql）中的每一条，您都需要发送以下信息：
            </p>
            <ul class="cnParagraph">
              <li style="margin-bottom: 20px;color:#409EFF">
                您认为最有价值的 alternative plan 的 ID 以及 您选择它的理由。
              </li>
              <li style="color: #409EFF">
                您认为的最没有价值的 alternative plan 的 ID 以及 您选择它的理由。
              </li>
            </ul>
            <p style="font-size: 14px;text-indent: 20px;font-style: italic;color:#909399" class="cnParagraph">
              (注： 如果您能通过某个 alternative plan 与 best plan 之间的对比掌握到有意思的信息，那么这个 alternative plan 就是有价值的。如果您无法了解到任何信息，那么它就是没有价值的。)
            </p>
            <p style="font-size: 14px;text-indent: 20px;font-style: italic;color:#409EFF" class="cnParagraph">
              (注： 发送反馈信息时，您无需指明这个反馈信息是关于 5.sql 的还是 6.sql 的。当页面上展示 5.sql 的结果时，您发送的反馈信息会自动与 5.sql 相关联，对于 6.sql 也一样。)
            </p>
            <p class="cnParagraph">
              将反馈信息输入到上图所示的表单中，并点击 "submit" 按钮进行提交。对于 "5.sql" 和 ”6.sql" 中的每一个，您都需要提交一次。
              如果您对同一个SQL进行重复提交，先前的反馈信息会被后面的信息覆盖。
            </p>
            <p class="cnParagraph">
              *** 这一步是用户调查的关键步骤，请您仔细完成 ***
            </p>
          </div>
        </el-card>
        <el-card v-show="activeStep === 4" style="height: 60vh;margin-top: 40px;font-size: 18px">
          <div style="text-align: center; margin-bottom: 20px">
            <img src="../assets/suggest.jpg" class="image">
          </div>
          <p class="cnParagraph">
            最后，如果您对 ARENA 系统有任何建议（无论是 ARENA 系统的功能还是它的展示界面或者其它的方面），请通过 Suggest 部分向我们发送反馈。
          </p>
          <p class="cnParagraph">
            本次问卷调查已结束，谢谢您的参与。
          </p>
        </el-card>
      </el-main>

      <el-footer class="footer">
        <el-form>
          <el-form-item>
            <el-button type="primary" style="width: 120px; margin-right: 40px" @click="previousStep">
              Previous Step
            </el-button>

            <el-button type="primary" style="width: 120px" @click="nextStep">
              Next Step
            </el-button>
          </el-form-item>
        </el-form>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "cnGuide",
  data() {
    return {
      activeStep: 0
    }
  },
  methods: {
    previousStep() {
      if (this.activeStep !== 0) {
        this.activeStep -= 1;
      }
    },

    nextStep() {
      if (this.activeStep < 4) {
        this.activeStep += 1
      }
    }
  }
}
</script>

<style scoped>
.layout-container .el-header {
  position: relative;
  background-color: #C6E2FF;
}

.layout-container .title{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #303133;
}

.layout-container .guideMenu{
  float: right;
}

.layout-container .el-footer {
  position: relative;
}

.guideMenu a {
  text-decoration: none;
}

.guideMenu .router-link-active {
  text-decoration: none;
}

.cnParagraph{
  letter-spacing: 2px;
}

</style>

<style>
.footer .el-form-item{
  text-align: center;
}

.guideMenu .el-submenu__title{
  font-size: 16px;
}

</style>
